type sourceItem = { name: string; items: sourceItem[] }

/**
 * 查找是否符合条件的资源
 * @param data /pt/ps/editor/file/list 接口返回的数据
 * @param cb 校验回调函数
 */
export function findTargetResource(
  data: { name: string; items: sourceItem[] | undefined },
  cb: (
    name: string,
    data: { name: string; items: sourceItem[] | undefined }
  ) => boolean
): string | undefined {
  if (cb(data.name, data)) {
    return data.name
  } else if (Array.isArray(data.items)) {
    for (const item of data.items) {
      const cur = findTargetResource(item, cb)
      if (cur) return cur
    }
  }
}

